import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../../lib/api";
import { SectionHeading } from "./CtaButtons";

const initials = (name = "") => name.replace(/^(Familie|Fam\.|Dhr\.|Mevr\.)\s*/i, "").split(/\s+/).filter(Boolean).slice(-1)[0]?.[0]?.toUpperCase() || "K";

export const HomeReviews = () => {
  const [reviews, setReviews] = useState([]);
  useEffect(() => {
    api.get("/reviews").then((r) => {
      const list = [...(r.data || [])].sort((a, b) => Number(!!b.featured) - Number(!!a.featured));
      setReviews(list.slice(0, 3));
    }).catch(() => setReviews([]));
  }, []);
  if (!reviews.length) return null;
  return (
    <section aria-labelledby="reviews-title" className="section" data-testid="home-reviews">
      <div className="container-tight">
        <SectionHeading id="reviews-title" eyebrow="Ervaringen" title="Wat klanten over ons zeggen" />
        <ul className="mt-10 grid gap-6 md:grid-cols-3">
          {reviews.map((r) => (
            <li key={r.id} className="card flex flex-col p-6 sm:p-7" data-testid={`review-card-${r.id}`}>
              <div className="flex gap-0.5 text-[#C9A24A]" role="img" aria-label={`${r.rating || 5} van de 5 sterren`}>
                {Array.from({ length: 5 }).map((_, i) => <Star key={i} className={`h-4 w-4 ${i < (r.rating || 5) ? "fill-current" : "text-slate-300"}`} aria-hidden="true" />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15.5px] leading-relaxed text-slate-700">“{r.text}”</blockquote>
              <footer className="mt-6 flex items-center gap-3 border-t border-slate-100 pt-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-maas-soft font-display font-bold text-maas" aria-hidden="true">{initials(r.name)}</span>
                <div>
                  <p className="font-semibold text-ink">{r.name}</p>
                  {r.place && <p className="text-[13px] text-slate-500">{r.place}</p>}
                </div>
              </footer>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
